import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// TODO: Replace with your actual Firebase configuration
// Import the functions you need from the SDKs you need
const firebaseConfig = {
  apiKey: "AIzaSyAaQhTV5SSswTwM41R8JwGC7rdavg-cRBA",
  authDomain: "rohit-rao-net.firebaseapp.com",
  projectId: "rohit-rao-net",
  storageBucket: "rohit-rao-net.firebasestorage.app",
  messagingSenderId: "301293464637",
  appId: "1:301293464637:web:52488f3e4792dafc658e54"
};

// const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "YOUR_AUTH_DOMAIN",
//   projectId: "YOUR_PROJECT_ID",
//   storageBucket: "YOUR_STORAGE_BUCKET",
//   messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
//   appId: "YOUR_APP_ID"
// };

const app = initializeApp(firebaseConfig);

// Lazy initialization to avoid permission issues
let db = null;
let storage = null;
let auth = null;

const getDbInstance = () => {
  if (!db) {
    try {
      db = getFirestore(app);
    } catch (error) {
      console.log('Firestore not available:', error);
      return null;
    }
  }
  return db;
};

const getStorageInstance = () => {
  if (!storage) {
    try {
      storage = getStorage(app);
    } catch (error) {
      console.log('Storage not available:', error);
      return null;
    }
  }
  return storage;
};

const getAuthInstance = () => {
  if (!auth) {
    try {
      auth = getAuth(app);
    } catch (error) {
      console.log('Auth not available:', error);
      return null;
    }
  }
  return auth;
};

export { getDbInstance, getStorageInstance, getAuthInstance }; 